@use "variables" as *;

.name {
  font-size: $fontSize-m;
  white-space: pre-wrap;
  text-align: center;
}

.isoCode {
  font-size: $fontSize-s;
  font-weight: lighter;
  white-space: pre-wrap;
  text-align: center;
}

.flag {
  font-size: $fontSize-xl;
  white-space: pre-wrap;
  text-align: center;
}

.skeleton {
  width: 100%;
  border-radius: 20px;
}
